import { cn } from '@/components/ui/utils';

export type TappLabelProps = React.ComponentProps<'label'>;

export const TappLabel: React.FC<TappLabelProps> = ({ className, ...props }) => {
  return <label className={cn('text-xs font-medium text-secondary-foreground', className)} {...props} />;
};
